import { Add as AddIcon } from '@material-ui/icons';
import { TabletButton } from '@campfire/tablet-button';
import { formatDistance, unpackToDateTime } from '@campfire/hot-date';
import React, { useState } from 'react';
import { LeftMenuItemType } from '../../incoming-volunteer-model.gql';
import { GetIncomingVolunteerProfile_vm_profile_application_applicationRoles as ApplicationRoles } from '../../__generated__/GetIncomingVolunteerProfile';
import { TaskPendingReviewIcon } from '../../../../../../common/icons/TaskPendingReviewIcon';
import { TaskCompleteIcon } from '../../../../../../common/icons/TaskCompleteIcon';
import { TaskRejectedIcon } from '../../../../../../common/icons/TaskRejectedIcon';
import { RoleIcon } from '../../../../../../common/icons/RoleIconList';
import { useCampfireTheme } from '../../../../../../theme/useCampfireTheme';
import { AddRoleApplicationDialog } from './AddRoleApplicationDialog';
import { IncomingVolunteerTaskList } from '../IncomingVolunteerTaskList';

interface Props {
  setLeftMenuItem: (x: LeftMenuItemType) => void;
  applicationRoles?: ApplicationRoles[];
  selectedApplicationRoleId?: string;
  userId?: string;
  refetch?: () => void;
}

const statusText = (status: string) =>
  status === 'pending' ? 'Pending review' : status === 'approved' ? 'Approved' : 'Rejected';

const IncomingVolunteerRolesSection = (props: Props) => {
  const { setLeftMenuItem, applicationRoles, selectedApplicationRoleId, userId, refetch } = props;
  const { theme } = useCampfireTheme();
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const existingRoleIds = (applicationRoles ?? []).map((r) => r.role.activityRoleId);

  return (
    <>
      {userId && refetch && (
        <AddRoleApplicationDialog
          open={addDialogOpen}
          onClose={() => setAddDialogOpen(false)}
          userId={userId}
          existingRoleIds={existingRoleIds}
          onSuccess={refetch}
        />
      )}
      <IncomingVolunteerTaskList
        header='Role Applications'
        headerAction={
          userId && refetch ? (
            <TabletButton
              variant='text'
              color='primary'
              size='small'
              startIcon={<AddIcon />}
              onClick={() => setAddDialogOpen(true)}
            >
              Add
            </TabletButton>
          ) : (
            undefined
          )
        }
        items={(applicationRoles ?? []).map((role) => ({
          taskId: role.applicationRoleId,
          icon:
            role.status === 'pending' ? (
              <TaskPendingReviewIcon />
            ) : role.status === 'approved' ? (
              <TaskCompleteIcon isComplete />
            ) : (
              <TaskRejectedIcon />
            ),
          taskTitle: role.role.name,
          titleIcon: role.role.icon ? (
            <RoleIcon
              iconName={role.role.icon}
              color={theme.color.grey.neutral300}
              style={{ height: '17px', paddingRight: '7px' }}
            />
          ) : (
            undefined
          ),
          taskSubText: statusText(role.status),
          taskRecentActivityStatus: role.dateActioned
            ? `Updated ${formatDistance(unpackToDateTime(role.dateActioned))}`
            : 'Not reviewed',
          selected: role.applicationRoleId === selectedApplicationRoleId,
          adminOnly: false,
          onClick: () =>
            setLeftMenuItem({
              applicationRoleId: role.applicationRoleId,
              type: 'VOLUNTEER_ApplicationRoleType',
            }),
        }))}
      />
    </>
  );
};

export { IncomingVolunteerRolesSection };
